import type { AssetViewModel } from '@trinnvis/dabih-api-client';
import type { OrganizationState } from '../../types';

import { toList } from '../toList';

export function assetHasPersonalDataItem(item: AssetViewModel, o: OrganizationState): boolean {
  return (
    toList(o.personalDataItemsById)
      .filter((e) => !e.deleted)
      .filter((e) => e.type === 'medicalEquipmentRecords')
      .filter((e) => Array.isArray(e.relatedAssets))
      .filter((e) => (e.relatedAssets ?? []).indexOf(item.uuid) !== -1).length > 0
  );
}

export function toAssetViewModel(
  item: AssetViewModel,
  o: OrganizationState,
): AssetViewModel & {
  hasPersonalDataItem: boolean;
  ownerDisplay: string;
  notes: string;
  requiredEventInstanceMissing: boolean;
  comments: string;
} {
  return Object.assign({}, item, {
    hasPersonalDataItem: assetHasPersonalDataItem(item, o),
    ownerDisplay: '',
    notes: '',
    requiredEventInstanceMissing: false,
    comments: '',
  });
}
